export default __webpack_public_path__ + "static/media/Flora 9781846165054.7b398c94.jpg";